import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePostStatus } from '../api/postApi';

export function usePostStatus(postId: string) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ status }: { status: 'draft' | 'published' }) =>
      updatePostStatus(postId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['posts'] });
      queryClient.invalidateQueries({ queryKey: ['posts', postId] });
    },
  });

  return {
    updateStatus: mutation.mutate,
    isUpdating: mutation.isPending,
    error: mutation.error,
  };
}